import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header/Header';
import Footer from './Footer/Footer';

function PublicLayout() {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh',
            backgroundColor: '#fff' 
        }}>
            <Header />
            
            {/* PaddingTop de 90px evita que o Header (fixed) 
                fique em cima do conteúdo inicial da página.
            */}
            <main style={{ 
                flex: 1, 
                paddingTop: '90px',
                width: '100%',
                margin: '0 auto'
            }}>
                <Outlet />
            </main>

            <Footer />
        </div>
    );
}

export default PublicLayout;